module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "whiteWrapper"
  }, [_c('h2', [_vm._v("\n    " + _vm._s(_vm.$t('form.warehouse.productTab.modal.title')) + "\n  ")]), _vm._v(" "), _c('v-form', {
    attrs: {
      "form": _vm.form,
      "translation": "form.warehouse.productTab.modal",
      "hasLabel": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex",
    staticStyle: {
      "flex-direction": "column"
    }
  }, [_c('el-button', {
    staticClass: "margin-b-20",
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6be43aea","hasScoped":false}!./src/app/components/minimumStock/minimumStock.html
// module id = 3050
// module chunks = 1